import { TextField as TextFieldMaterial, TextFieldProps } from '@mui/material';
import { memo } from 'react';
import PmiTooltipError from '../tooltip-error';

export type PmiTextFieldProps = Omit<TextFieldProps, 'helperText'> & { helperText?: string };

const TextFieldComponent = ({
  helperText,
  error,
  ...props
}: PmiTextFieldProps): React.ReactElement => {
  return (
    <PmiTooltipError message={helperText} show={error}>
      <span style={{ width: '100%' }}>
        <TextFieldMaterial error={error} {...props} size="small" />
      </span>
    </PmiTooltipError>
  );
};

TextFieldComponent.displayName = 'Text Field component';

export const PmiTextField = memo(TextFieldComponent) as typeof TextFieldComponent;

export default PmiTextField;
